<template>
  <el-cascader 
    v-model="selection" 
    :options="options"
    :props="props"
    @change="handleChange" 
    @expand-change="handleExpandChange"
    :placeholder="placeholder" 
    style="width:100%;"
  ></el-cascader>
</template>

<script>
export default {
  name: 'GrammarSelect',
  props: {
    value: Array,
    types: Array,
    placeholder: String
  },
  data () {
    return {
      selection: [],
      options: [],
      checkedValue: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'items',
        multiple: true, 
        checkStrictly: true
      }
    }
  },
  watch: {
    value () {
      if(this.checkedValue !== this.value) {
        this.initSelection()
      }
    }
  },
  created () {
    this.fetchData(0).then(res => {
      this.options = res.data.map(n => this.initItem(n))
      this.initSelection()
    })
  },
  methods: {
    fetchData (pid) {
      return this.$http.get(this.$urls.grammar_type_treelist, {
        params: { pid: pid || 0}
      })
    },
    initSelection () {
      if (this.options.length === 0 || !this.types) return
      this.initOptions(this.options, this.types).then((s) => {
        this.selection = s
      })
    },
    initOptions (options, types) {
      let defs = []
      options.forEach(opt => {
        types.forEach(t => {
          if (t.id === opt.id) {
            defs.push(Promise.resolve([[opt.id]]))
          } else if (t.root === opt.root && t.lft > opt.lft && t.rgt < opt.rgt) {
            let def = new Promise((r, j) => {
              this.loadNodes(opt).then(() => {
                this.initOptions(opt.items, [t]).then((sel) => {
                  r(sel.map(s => [opt.id, ...s]))
                })
              })
            })
            defs.push(def)
          }
        })
      })
      return Promise.all(defs).then(res => {
        return Array.prototype.concat.apply([], res)
      })
    },
    handleChange (val) {
      this.checkedValue = this.selection.map(n => n[n.length - 1])
      this.$emit('input', this.checkedValue)
    },
    handleExpandChange (val) {
      let node = {items: this.options}
      val.forEach(id => {
        node = node.items.find(n => n.id === id)
      })
      if (node.items.length === 0) {
        this.loadNodes(node)
      }
    },
    loadNodes (node) {
      if (node.load) {
        return node.load
      }
      return node.load = new Promise((r, j) => {
        if (node.items !== null && node.items.length === 0) {
          this.$http.get(this.$urls.grammar_type_treelist, {
            params: { pid: node.id }
          }).then(res => {
            res.data.forEach(n => {
              node.items.push(this.initItem(n))
            })
            return r(node)
          })
        } else {
          return r(node)
        }
      })
    },
    initItem (n) {
      let leaf = n.rgt - n.lft === 1
      return {
        id: n.id,
        name: n.name,
        root: n.root,
        lft: n.lft,
        rgt: n.rgt,
        leaf,
        items: leaf ? null : []
      }
    },
  }
}
</script>